import React from 'react';
import { Box, } from '@waglabs/box-next';
export const ModalHeader = (props) => (React.createElement(Box, Object.assign({ backgroundPosition: "bottom", backgroundRepeat: "no-repeat", backgroundSize: "cover", pt: ['24px', '32px'], px: ['24px', '32px'] }, props)));
